import { v4 as uuid } from 'uuid'

export const UPLOAD_ATTEMPT_ID_HEADER = 'X-CLF-Upload-Attempt-Id'

export const createUploadAttemptId = (): string => uuid()
